import { render, staticRenderFns } from "./ManagementServicesPage.vue?vue&type=template&id=cb29aef4&scoped=true"
import script from "./ManagementServicesPage.vue?vue&type=script&lang=js"
export * from "./ManagementServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementServicesPage.vue?vue&type=style&index=0&id=cb29aef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29aef4",
  null
  
)

export default component.exports